'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var styled = require('styled-components');

var forIE = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        ", "\n    }\n"], ["\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var isIE = function () {
    var _a;
    if (typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent)) {
        return /MSIE|Trident/.test(window.navigator.userAgent);
    }
    return false;
};
var forEdge = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    @supports (-ms-accelerator: true) or (-ms-ime-align: auto) {\n        ", "\n    }\n"], ["\n    @supports (-ms-accelerator: true) or (-ms-ime-align: auto) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var forIEandEdge = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n"])), forIE.apply(void 0, args), forEdge.apply(void 0, args));
};
var forSafari14andBefore = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    @supports (not (aspect-ratio: 1 / 1)) and (background: -webkit-named-image()) {\n        ", "\n    }\n"], ["\n    @supports (not (aspect-ratio: 1 / 1)) and (background: -webkit-named-image()) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var forSafari = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    @supports (background: -webkit-named-image()) {\n        ", "\n    }\n"], ["\n    @supports (background: -webkit-named-image()) {\n        ", "\n    }\n"])), styled.css.apply(void 0, args));
};
var minmaxMatchRegex = /minmax\(\s*\w*-*\w*\s*,\s*\w*-*\w*\s*\)/g;
var safari10MinMaxFallBack = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var safari10fallback = args.map(function (cssProperty) {
        return cssProperty.toString().replace(minmaxMatchRegex, 'auto');
    });
    return styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n        ", "\n        ", "\n    "], ["\n        ", "\n        ", "\n    "])), safari10fallback.join(''), styled.css.apply(void 0, args));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.forEdge = forEdge;
exports.forIE = forIE;
exports.forIEandEdge = forIEandEdge;
exports.forSafari = forSafari;
exports.forSafari14andBefore = forSafari14andBefore;
exports.isIE = isIE;
exports.safari10MinMaxFallBack = safari10MinMaxFallBack;
//# sourceMappingURL=browser.utils-bfcc05c6.js.map
